// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CreateListBlock_wrapper__huy_6","buttonGroup":"CreateListBlock_buttonGroup__VM92S","marginBottom":"CreateListBlock_marginBottom__jxw6B"};